var exports = {
  "Pe": "x4ddf2309--680f19--list-container",
  "p_": "x4ddf2309--680f19--list",
  "x3": "x4ddf2309--680f19--list-item",
  "eD": "x4ddf2309--680f19--list-item_description",
  "yc": "x4ddf2309--680f19--list-item_link",
  "Rc": "x4ddf2309--680f19--list-item_icon",
  "yy": "x4ddf2309--680f19--list-group-title",
  "xV": "x4ddf2309--680f19--list-group-icon",
};

module.exports = exports;
